import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from "contentful";
import type { TypeLogoWithQuoteSkeleton } from "./TypeLogoWithQuote";
import type { TypeTableOfContentsSettingSkeleton } from "./TypeTableOfContentsSetting";

/**
 * Fields type definition for content type 'TypeLogoWithQuoteSection'
 * @name TypeLogoWithQuoteSectionFields
 * @type {TypeLogoWithQuoteSectionFields}
 * @memberof TypeLogoWithQuoteSection
 */
export interface TypeLogoWithQuoteSectionFields {
    /**
     * Field type definition for field 'subHeader' (Header)
     * @name Header
     * @localized false
     */
    subHeader?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'logos' (Logos)
     * @name Logos
     * @localized false
     */
    logos?: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeLogoWithQuoteSkeleton>>;
    /**
     * Field type definition for field 'internalTitle' (Internal Title)
     * @name Internal Title
     * @localized false
     */
    internalTitle?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'tocSetting' (tocSetting)
     * @name tocSetting
     * @localized false
     */
    tocSetting?: EntryFieldTypes.EntryLink<TypeTableOfContentsSettingSkeleton>;
}

/**
 * Entry skeleton type definition for content type 'logoWithQuoteSection' (Logo With Quote Section)
 * @name TypeLogoWithQuoteSectionSkeleton
 * @type {TypeLogoWithQuoteSectionSkeleton}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-27T23:29:32.141Z
 * @version 7
 */
export type TypeLogoWithQuoteSectionSkeleton = EntrySkeletonType<TypeLogoWithQuoteSectionFields, "logoWithQuoteSection">;
/**
 * Entry type definition for content type 'logoWithQuoteSection' (Logo With Quote Section)
 * @name TypeLogoWithQuoteSection
 * @type {TypeLogoWithQuoteSection}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-27T23:29:32.141Z
 * @version 7
 */
export type TypeLogoWithQuoteSection<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<TypeLogoWithQuoteSectionSkeleton, Modifiers, Locales>;

export function isTypeLogoWithQuoteSection<Modifiers extends ChainModifiers, Locales extends LocaleCode>(entry: Entry<EntrySkeletonType, Modifiers, Locales>): entry is TypeLogoWithQuoteSection<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'logoWithQuoteSection'
}
